import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { noop } from 'lodash';
import { func, number } from 'prop-types';
import React from 'react';
import s from './style.css';

const zeroPad = (value, length) => `${value}`.padStart(length, '0');
class CircularProgressBar extends React.Component {
  static propTypes = {
    sqSize: number,
    strokeWidth: number,
    seconds: number,
    changeSecond: func,
    defaultTimeout: number,
  };

  static defaultProps = {
    sqSize: 200,
    strokeWidth: 10,
    seconds: 90,
    changeSecond: noop,
    defaultTimeout: 90,
  };
  constructor(props) {
    super(props);
    this.countDownId = null;
  }

  componentDidMount() {
    this.startTimer();
  }
  componentWillUnmount() {
    this.stopTimer();
  }

  startTimer = () => {
    this.countDownId = setInterval(() => {
      const { seconds, changeSecond } = this.props;
      changeSecond(seconds - 1 >= 0 ? seconds - 1 : 0);
    }, 1000);
  };
  stopTimer = () => {
    clearInterval(this.countDownId);
  };
  renderCountDown = timer => {
    const second = timer % 60;
    const minute = Math.floor(timer / 60);
    return `${zeroPad(minute, 2)}:${zeroPad(second, 2)}`;
  };
  render() {
    const { seconds, defaultTimeout } = this.props;

    // Size of the enclosing square
    // eslint-disable-next-line prefer-destructuring
    const sqSize = this.props.sqSize;
    // SVG centers the stroke width on the radius, subtract out so circle fits in square
    const radius = (this.props.sqSize - this.props.strokeWidth) / 2;
    // Enclose cicle in a circumscribing square
    const viewBox = `0 0 ${sqSize} ${sqSize}`;
    // Arc length at 100% coverage is the circle circumference
    const dashArray = radius * Math.PI * 2;
    // Scale 100% coverage overlay with the actual percent
    const dashOffset = dashArray - (dashArray * seconds) / defaultTimeout;
    return (
      <svg
        width={this.props.sqSize}
        height={this.props.sqSize}
        viewBox={viewBox}
      >
        <circle
          className={s.circleBackground}
          cx={this.props.sqSize / 2}
          cy={this.props.sqSize / 2}
          r={radius}
          strokeWidth={`${this.props.strokeWidth}px`}
        />
        <circle
          className={s.circleProgress}
          cx={this.props.sqSize / 2}
          cy={this.props.sqSize / 2}
          r={radius}
          strokeWidth={`${this.props.strokeWidth}px`}
          // Start progress marker at 12 O'Clock
          transform={`rotate(-90 ${this.props.sqSize / 2} ${this.props.sqSize /
            2})`}
          style={{
            strokeDasharray: dashArray,
            strokeDashoffset: dashOffset,
          }}
        />
        <text
          className={s.circleText}
          x="50%"
          y="50%"
          dy=".3em"
          textAnchor="middle"
        >
          {this.renderCountDown(seconds)}
        </text>
      </svg>
    );
  }
}

export default withStyles(s)(CircularProgressBar);
